/** Homepage brand positioning — Pick Pack Pro vs generic UK 3PLs (no duplicate of testimonials data). */
export const PPP_VS_GENERIC_3PL_ROWS = [
  {
    feature: 'Amazon FBA prep & compliance',
    generic: 'Ad-hoc labelling; inconsistent QC',
    ppp: 'Dedicated prep bench, FNSKU/polybag SOPs, carton-ready outbound',
  },
  {
    feature: 'Seller Fulfilled Prime readiness',
    generic: 'Weekday-only dispatch; manual carrier labels',
    ppp: '7-day SFP dispatch, Buy Shipping workflows, weekend cut-offs',
  },
  {
    feature: 'Channel integrations',
    generic: 'Limited marketplace connectors',
    ppp: '650+ integrations — Amazon, Shopify, TikTok Shop & more',
  },
  {
    feature: 'Visibility & reporting',
    generic: 'Spreadsheet updates; delayed stock counts',
    ppp: 'WMS-backed inventory, Mintsoft portal, same-day goods-in updates',
  },
  {
    feature: 'Pricing transparency',
    generic: 'Hidden surcharges; unclear prep line items',
    ppp: 'Published FBA prep from 30p/unit; itemised quotes before batch work',
  },
] as const;

export const BRAND_OUTCOME_HIGHLIGHTS = [
  {
    metric: '5.0★',
    label: 'Google rating',
    detail: 'Verified UK seller reviews',
    href: '/our-reviews',
  },
  {
    metric: '99.9%',
    label: 'Picking accuracy',
    detail: 'Operational SLA target',
    href: '/case-studies',
  },
  {
    metric: 'From 30p',
    label: 'FBA prep / unit',
    detail: 'Published UK prep pricing',
    href: '/amazon-fba-prep-pricing',
  },
] as const;
